/**
 * @fileoverview POST handler for the "/integrations/voucher_groups/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsVoucherGroupsTagsCacheKeys } from "./constants";
import type { IntegrationsVoucherGroupsTagsParams, IntegrationsVoucherGroupsTagsResult } from "./types";

export const postIntegrationsVoucherGroupsTags = reactQueryMutationAdapter(
  integrationsVoucherGroupsTagsCacheKeys,
  ({
    app_group_id,
    desired_state,
    undo_identifier,
  }: IntegrationsVoucherGroupsTagsParams): Promise<IntegrationsVoucherGroupsTagsResult> => {
    return fetch("/integrations/voucher_groups/tags", "POST", {
      app_group_id,
      desired_state,
      undo_identifier,
    });
  }
);
